<template>
  <data-list
    ref="dataList"
    class="content"
    url="/activity/activity-delivery-set"
    entity-name="车型"
    add-btn="添加车型"
    hide-show-detail
    :before-update="beforeUpdate"
    :hide-action="!editable"
    :modal-width="600"
    :modal-form="modalForm"
    :query="query"
    :action="action"
    :columns="columns"
    :rules="rules">
    <template v-slot:edit="{form}">
      <a-form-model-item label="车型（中文）" prop="chinese_name">
        <a-input v-model="form.chinese_name" placeholder="请输入订餐时间（中文）"></a-input>
      </a-form-model-item>
      <a-form-model-item label="车型（英文）" prop="english_name">
        <a-input v-model="form.english_name" placeholder="请输入订餐时间（英文）"></a-input>
      </a-form-model-item>
      <a-form-model-item label="价格（人民币）" prop="price">
        <a-input-number :min="0" v-model="form.price" placeholder="请输入格（人民币）" style="width: 100%;"></a-input-number>
      </a-form-model-item>
      <a-form-model-item label="价格（美元）" prop="dollar">
        <a-input-number :min="0" v-model="form.dollar" placeholder="请输入格（美元）" style="width: 100%;"></a-input-number>
      </a-form-model-item>
    </template>
  </data-list>
</template>

<script>
    import mixins from "../mixins";

    export default {
        name: "DeliveryCar",
        data() {
            return {
                dateList: [],
                timeList: [],
                columns: [
                    {title: '订餐时间（中文）', dataIndex: 'chinese_name'},
                    {title: '订餐时间（英文）', dataIndex: 'english_name'},
                    {title: '价格（人民币）', dataIndex: 'price'},
                    {title: '价格（美元）', dataIndex: 'dollar'},
                ],
                rules: {
                    chinese_name: [{ required: true, message: '请输入订餐时间（中文）', trigger: 'blur' }],
                    english_name: [{ required: true, message: '请输入订餐时间（英文）', trigger: 'blur' }],
                    price: [{ required: true, message: '请输入价格（人民币）', trigger: 'blur' }],
                    dollar: [{ required: true, message: '请输入价格（美元）', trigger: 'blur' }],
                },
                modalForm: {
                    labelAlign: 'left',
                    labelCol: {span: 6},
                    wrapperCol: {span: 18}
                },
                moduleKey: 'delivery-car',
            }
        },
        mixins: [mixins],
        computed: {
            action() {
                return this.editable ? ['add', 'delete', 'update', 'query', 'audit'] : ['query'];
            },
            activity() {
                return this.$store.getters.activity;
            },
            query() {
                let res = '';
                const activity = this.activity;
                if(activity) {
                    res += `&filter[activity_id]=${activity.id}`
                }
                return res;
            }
        },
        methods: {
            beforeUpdate(form, fn) {
                if(!form.id) {
                    form.activity_id = this.activity.id;
                }
                fn();
            },

        }
    }
</script>

<style scoped lang="less">
</style>
